import { datadogLogs } from '@datadog/browser-logs';

export const trackBtnClick = (email, tenantId, action, view, ...rest) => {
  const details = rest?.[0]?.details || rest?.[0] || {};
  datadogLogs.logger.debug(`[BTN CLICK] ${email} ${action} from the ${view} view (Tenant ID: ${tenantId})`, details);
};
